<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">Company Profile</div>
      <div class="d-flex justify-content-end" *rbacAllow="[true]">
        <button
          id="update"
          class="btn btn-secondary btn-sm"
          type="button"
          (click)="toggleDisabled()"
        >
          Edit
        </button>
        <div class="ml-3" *ngIf="IsHidden">
          <button
            class="btn btn-secondary btn-sm"
            type="button"
            (click)="updateProfile()"
          >
            update
          </button>
        </div>
      </div>
    </div>

    <div class="row my-5">
      <div class="col-lg-8 col-sm-12 my-3">
        <div class="bg-white border-radius px-4 py-2">
          <div class="row">
            <div class="col-lg-9 col-sm-12">
              <form action="" [formGroup]="profileForm">
                <div class="my-4">
                  <label class="font12 text-grey">ORGANISATION NAME</label>
                  <input
                    type="text"
                    class="common-input"
                    formControlName="name"
                  />
                </div>
                <div class="my-4">
                  <label class="font12 text-grey">EMAIL ADDRESS</label>
                  <input
                    type="email"
                    class="common-input"
                    disabled
                    placeholder="{{ profile?.email }}"
                  />
                </div>
                <div class="my-4">
                  <label class="font12 text-grey">PHONE NUMBER</label>
                  <input
                    type="number"
                    class="common-input"
                    formControlName="phoneNumber"
                  />
                </div>
                <div class="my-4">
                  <label class="font12 text-grey">OFFICE ADDRESS</label>
                  <input
                    type="text"
                    class="common-input"
                    formControlName="address"
                  />
                </div>
                <div class="my-4">
                  <label class="font12 text-grey">BRIEF DESCRIPTION</label>
                  <textarea
                    type="text"
                    class="common-input"
                    formControlName="description"
                  ></textarea>
                </div>
                <div class="my-4">
                  <label class="font12 text-grey">COMPANY WEBSITE</label>
                  <input
                    type="text"
                    class="common-input"
                    formControlName="website"
                  />
                </div>
                <div class="my-4">
                  <label class="font12 text-grey">COMPANY SIZE</label>
                  <input
                    type="text"
                    class="common-input"
                    placeholder="{{ profile.expectedNoOfUser }}"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12 my-3">
        <div class="bg-white border-radius p-4">
          <div class="d-flex justify-content-between pb-4">
            <p class="text-grey font12 pt-2">CONTACT PERSON</p>
            <button
              class="btn btn-outline-secondary btn-sm"
              data-toggle="modal"
              data-target="#addContactPersonModal"
            >
              Add More
            </button>
          </div>
          <div class="p-4 d-flex align-items-center border-radius bg-grey">
            <div class="profile mr-3">
              <img
                src="{{
                  profile?.user?.avatarUrl
                    ? profile?.user?.avatarUrl
                    : 'assets/images/avatar.jpg'
                }}"
                alt=""
                class=""
                width="50"
                height="50"
              />
            </div>
            <div>
              <p class="mb-1 font-bold">{{ profile?.contactPerson }}</p>
              <p class="mb-0 text-grey font14">
                {{ profile?.email }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>

<!--Modal-->

<app-modal
  elementId="addContactPersonModal"
  headerTitle="Add Contact Person"
  centered="true"
  [styles]="{
    modalBodyHeight: '250px',
    modalContentWidth: '421px'
  }"
>
  <div class="content" [formGroup]="profileForm">
    <hr class="hline" />
    <div class="row mt-5">
      <div class="d-flex justify-content-center col-12 mb-3">
        <input
          type="text"
          class="common-input"
          placeholder="Full Name"
          formControlName="contactPerson"
        />
        <span class="text-danger">*</span>
      </div>
      <!-- <div class="d-flex justify-content-center col-12 mb-4">
        <input
          type="text"
          class="common-input"
          placeholder="Contact email"
          formControlName="contactPersonEmail"
        />
        <span class="text-danger">*</span>
      </div> -->
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button data-dismiss="modal" class="modalBtn btn-secondary" type="button">
        Add Contact Person
      </button>
    </div>
  </div>
</app-modal>
